import AuthenticatedController from './AuthenticatedController';
import { NOTIFICATIONS } from '@mm/api-routes';

class NotificationController extends AuthenticatedController {
  static async getAll(botId: number) {
    const response = await super.get(NOTIFICATIONS(botId));

    return response;
  }

  static async snooze(botId: number) {
    const response = await super.post(`${NOTIFICATIONS(botId)}/snooze`);

    return response;
  }

  static async check(botId: number, notificationId: number) {
    const response = await super.post(
      `${NOTIFICATIONS(botId)}/${notificationId}/check`,
    );

    return response.notifications;
  }
}

export default NotificationController;
